export default {
    config: function() {
        var config = {
            preview: "/main/preview",
        }
        return config;
    },
}
